module.exports = __webpack_public_path__ + "static/img/role.646f1ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/tsz/role.png
// module id = kd2n
// module chunks = 7